module.exports = __webpack_public_path__ + "static/media/icon_edit.b75a4de5.svg";